// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-2f971178","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ConfirmEmail.vue
// module id = 253
// module chunks = 0